import { render, staticRenderFns } from "./ResearchRegionPlot.vue?vue&type=template&id=61152358"
import script from "./ResearchRegionPlot.vue?vue&type=script&lang=js"
export * from "./ResearchRegionPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchRegionPlot.vue?vue&type=style&index=0&id=61152358&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61152358')) {
      api.createRecord('61152358', component.options)
    } else {
      api.reload('61152358', component.options)
    }
    module.hot.accept("./ResearchRegionPlot.vue?vue&type=template&id=61152358", function () {
      api.rerender('61152358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchRegionPlot.vue"
export default component.exports